import MForm from "../../modules/MForm";
import MDiaryDay from "./MDiaryDay";

export default class MDiaryDayForm extends MForm
{
	getDiaryDay()
	{
		return new MDiaryDay(this.el.closest(".diary-day"));
	}
}
